import { createContext, useContext } from "react";

interface IMenuContext {
  open?: boolean;
  setOpen?: (open: boolean) => void;
}

const MenuContext = createContext<IMenuContext>({});

export const MenuContextProvider = MenuContext.Provider;
export const MenuContextConsumer = MenuContext.Consumer;

export const useMenuContext = (): IMenuContext => useContext(MenuContext);

export default MenuContext;
